(() => {
  document.querySelectorAll('.sh-product-reviews').forEach(root => {
    const source = root.querySelector('.sh-judge-source')?.content;
    const target = root.querySelector('.sh-product-quotes');
    if (!source || !target) return;
    const seen = new Set();
    const reviews = Array.from(source.querySelectorAll('.jdgm-rev')).filter(review => {
      const text = review.querySelector('.jdgm-rev__body')?.textContent.trim();
      const rating = Number(review.querySelector('.jdgm-rev__rating')?.getAttribute('data-score'));
      if (!text || text.length < 20 || text.length > 900 || !Number.isInteger(rating) || rating < 4 || rating > 5 || seen.has(text)) return false;
      seen.add(text);
      return true;
    }).slice(0, 2);
    if (!reviews.length) { root.hidden = true; return; }
    reviews.forEach(review => {
      const card = document.createElement('figure');
      card.className = 'ch-real-review';
      card.dataset.reviewId = review.dataset.reviewId || '';
      const rating = Number(review.querySelector('.jdgm-rev__rating').getAttribute('data-score'));
      const stars = document.createElement('span');
      stars.className = 'ch-review-stars';
      stars.setAttribute('aria-label', `${rating} out of 5 stars`);
      stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
      const quote = document.createElement('blockquote');
      quote.textContent = review.querySelector('.jdgm-rev__body').textContent.trim();
      const caption = document.createElement('figcaption');
      const name = document.createElement('strong');
      name.textContent = review.querySelector('.jdgm-rev__author')?.textContent.trim() || '';
      caption.append(name);
      if (review.dataset.verifiedBuyer === 'true') {
        const verified = document.createElement('span');
        verified.className = 'ch-review-verified';
        verified.textContent = 'Verified reviewer';
        caption.append(verified);
      }
      card.append(stars, quote, caption);
      target.append(card);
    });
  });
})();
